import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	defaultErrorFlagTitle: {
		id: 'jira-horizontal-nav-tab-menu.services.rename-navigation-item.default-error-flag-title',
		defaultMessage: "We couldn't update the view name",
		description: 'Default flag title when the request to rename a view has failed.',
	},
	defaultErrorFlagDescription: {
		id: 'jira-horizontal-nav-tab-menu.services.rename-navigation-item.default-error-flag-description',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Default flag description when the request to rename a view has failed.',
	},
	userNotLoggedInErrorFlagTitle: {
		id: 'jira-horizontal-nav-tab-menu.rename-navigation-item.user-not-logged-in-error-flag-title',
		defaultMessage: "You'll need to log in",
		description:
			'Flag title when the request to rename a view fails due to the user not being logged in.',
	},
	userNotLoggedInErrorFlagDescription: {
		id: 'jira-horizontal-nav-tab-menu.rename-navigation-item.user-not-logged-in-error-flag-description',
		defaultMessage: 'You need to be logged in to rename this view. Please log in and try again.',
		description:
			'Flag description when the request to rename a view has failed due to the user not being logged in.',
	},
	userNotAdminErrorFlagTitle: {
		id: 'jira-horizontal-nav-tab-menu.rename-navigation-item.user-not-admin-error-flag-title',
		defaultMessage: "You don't have permission",
		description:
			'Flag title when the request to rename a view has failed due to the user not being allowed.',
	},
	userNotAdminErrorFlagDescription: {
		id: 'jira-horizontal-nav-tab-menu.rename-navigation-item.user-not-admin-error-flag-description',
		defaultMessage: 'You are not allowed to rename views.',
		description:
			'Flag description when the request to rename a view has failed due to the user not being allowed.',
	},
});
